<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN" id="_idParaDest-5"> </p>
<p class="Q_F ParaOverride-5"><span class="CharOverride-7">Language is a skin: I rub my language against the other. It is as if I had words instead of fingers, or fingers at the tip of my words. My language trembles with desire.</span></p>
<p class="Q_F ParaOverride-6"><span class="CharOverride-8">—</span><span class="I CharOverride-9">Fragments d’un discours amoureux</span><span class="CharOverride-8">,</span></p>
<p class="Q_F ParaOverride-6"><span class="CharOverride-8">Roland Barthes</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97808021495414.vue?9ecc4dbc